import { useReferralPageContext } from 'contexts/referral';
import { DateTime } from 'luxon';
import { LUXON_MIDNIGHT } from 'utils/date';

export const NEARLY_EXPIRES_IN_DAYS = 10;

export const useGetIsReferralCampaignNearlyExpired = () => {
  const { referralCampaign } = useReferralPageContext();

  const endDate = DateTime.fromISO(referralCampaign?.endDate as any).set(LUXON_MIDNIGHT);
  const dateDiff = endDate.diffNow('days').toObject();
  return (dateDiff as any)?.days <= NEARLY_EXPIRES_IN_DAYS;
};
